export default "/images/vendor/flag-icon-css/flags/1x1/nu.svg?9deebec59d90dece17fc9c87e82b6ff0";